"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var createTransitionMap = function createTransitionMap(key) {
  return function (map) {
    return function (props) {
      var switchKey = props[key];
      var transition = map[switchKey] || map.default;
      return transition ? transition(props) : false;
    };
  };
};

exports.eachValue = createTransitionMap('key');
exports.fromPose = createTransitionMap('prevPoseKey');